<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="会员ID：" prop="member_id">
                <span>{{model.member_id}}</span>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
                <span>{{model.email}}</span>
            </el-form-item>
            <el-form-item label="车表ID：" prop="car_info_id">
                <span>{{model.car_info_id}}</span>
            </el-form-item>
            <el-form-item label="车辆ID：" prop="vehicle_id">
                <span>{{model.vehicle_id}}</span>
            </el-form-item>
            <el-form-item label="VIN：" prop="vin">
                <span>{{model.vin}}</span>
            </el-form-item>
            <el-form-item label="车型：" prop="car_type">
                <span>{{model.car_type}}</span>
            </el-form-item>
            <el-form-item label="版本：" prop="version">
                <span>{{model.version}}</span>
            </el-form-item>
            <el-form-item label="交付日期：" prop="delivered_date">
                <span>{{model.delivered_date}}</span>
            </el-form-item>
            <el-form-item label="满电续航(km)：" prop="full_endurance">
                <span>{{model.full_endurance}}</span>
            </el-form-item>
            <el-form-item label="电池容量(度)：" prop="full_battery_capacity">
                <span>{{model.full_battery_capacity}}</span>
            </el-form-item>
            <el-form-item label="提交时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'batteryFeedbackInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                email: '',
                car_info_id: '',
                vehicle_id: '',
                vin: '',
                car_type: '',
                version: '',
                delivered_date: '',
                full_endurance: '',
                full_battery_capacity: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/batteryfeedback/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>